module.exports = __webpack_public_path__ + "8d73b920742f1f48d338ffb0a868bc47.svg";